<template>
    <div class="second-level-tabs pt-2">
        <v-tabs v-model="productTab" center-active color="primary" height="30" class="mb-6">
            <v-tab v-for="tab in tabs" :key="tab" :value="tab" class="text-caption text-primary">
                {{ translationKey ? $t(`${translationKey}.${tab}`) : $t(`${tab}`) }}
            </v-tab>
        </v-tabs>
        <v-tabs-window v-model="productTab">
            <v-tabs-window-item v-for="tab in tabs" :key="tab" :value="tab"><slot :name="tab" /></v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        tabs: string[]
        translationKey?: string
    }>()

    const productTab = ref<string>(props.tabs[0])
</script>
